import { render, staticRenderFns } from "./payrollRecord.vue?vue&type=template&id=a8b793e2&scoped=true&"
import script from "./payrollRecord.vue?vue&type=script&lang=js&"
export * from "./payrollRecord.vue?vue&type=script&lang=js&"
import style0 from "./payrollRecord.vue?vue&type=style&index=0&id=a8b793e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b793e2",
  null
  
)

export default component.exports